module.exports = __webpack_public_path__ + "static/media/ic_tv_-1.8b935b7d.svg";